import {connect} from '@modifi/redux'
import {FeInputFieldStatusVal} from '@modifi/enums'

import {SectionNavigationItem} from '../../../../plugins/onboarding'
import {
  selectNavigationItems,
  aInitializeNavigationTargets,
  selectNavigationItemStatus,
} from '../../store'
import {STATIC_SECTIONS} from '../../../../constants/section-to-input-fields'
import {selectInputFieldsBySectionName} from '../../../../modules/input-fields'

const mapStateToProps = (
  state: Record<string, any>,
  ownProps: {sectionName?: string | null}
): {
  hasSubNavigation: boolean
  childRoutes: string[]
  status: FeInputFieldStatusVal | null
  isNavItemVisible: boolean
} => {
  const subNavitems = ownProps.sectionName && selectNavigationItems(state, ownProps.sectionName)
  let showNavItem = false
  if (ownProps.sectionName) {
    if (STATIC_SECTIONS.includes(ownProps.sectionName)) {
      showNavItem = true
    }
    const inputFields = selectInputFieldsBySectionName(state, ownProps.sectionName)
    if (inputFields.length > 0) {
      showNavItem = true
    }
  }

  return {
    isNavItemVisible: showNavItem,
    hasSubNavigation: !!(subNavitems && subNavitems?.length > 0),
    childRoutes: subNavitems ? subNavitems.map(navItem => navItem.route) : [],
    status: ownProps.sectionName ? selectNavigationItemStatus(state, ownProps.sectionName) : null,
  }
}

const mapDispatchToProps = {
  init: aInitializeNavigationTargets,
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionNavigationItem)
